import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../api";
import { useAuth } from "../AuthContext";
import { Btn, Pill, Modal } from "../ui";

export default function Account() {
  const { user, logout } = useAuth();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const signOut = () => {
    logout();
    navigate("/auth");
  };

  const deleteAccount = async () => {
    setBusy(true);
    try {
      await api.delete("/auth/account");
      logout();
      navigate("/");
    } catch {
      toast.error("Could not delete the account.");
      setBusy(false);
    }
  };

  return (
    <div data-testid="account-page" className="max-w-2xl">
      <p className="font-mono-label text-[10px] tracking-[0.3em] uppercase text-[#B5A58A]/80 mb-4">Account</p>
      <h1 className="font-serif-display font-light tracking-tighter text-5xl md:text-6xl text-white mb-12">Your seat.</h1>

      <div className="bg-[#26241F] border border-white/[0.08] rounded-2xl p-8 space-y-6 mb-8">
        <div>
          <p className="font-mono-label text-[9px] tracking-[0.2em] uppercase text-stone-500 mb-1.5">Name</p>
          <p className="text-sm text-stone-200" data-testid="account-name">{user?.name || "—"}</p>
        </div>
        <div>
          <p className="font-mono-label text-[9px] tracking-[0.2em] uppercase text-stone-500 mb-1.5">Email</p>
          <p className="text-sm text-stone-200" data-testid="account-email">{user?.is_guest ? "Guest session (no email)" : user?.email}</p>
        </div>
        <div>
          <p className="font-mono-label text-[9px] tracking-[0.2em] uppercase text-stone-500 mb-1.5">Plan</p>
          <Pill tone="accent">Free — early access</Pill>
        </div>
      </div>

      <div className="flex gap-3 flex-wrap">
        <Btn testid="account-sign-out-btn" variant="outline" onClick={signOut}>Sign out</Btn>
        {!user?.is_guest && (
          <Btn testid="account-delete-btn" variant="ghost" className="text-[#B37D3B]" onClick={() => setConfirming(true)}>
            Delete account
          </Btn>
        )}
      </div>

      <Modal open={confirming} onClose={() => setConfirming(false)} testid="delete-account-modal">
        <h3 className="font-serif-display font-light tracking-tight text-3xl text-white mb-4">Delete your account?</h3>
        <p className="text-sm leading-relaxed text-stone-400 mb-8">
          Your cases, reviews, and decision profile will be deleted or de-identified. Public archive entries remain anonymous and unattributed. This cannot be undone.
        </p>
        <div className="flex flex-col gap-3">
          <Btn testid="confirm-delete-btn" onClick={deleteAccount} disabled={busy}>{busy ? "Deleting…" : "Delete everything"}</Btn>
          <Btn testid="cancel-delete-btn" variant="outline" onClick={() => setConfirming(false)}>Keep my account</Btn>
        </div>
      </Modal>
    </div>
  );
}
